import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { authLogout as authLogoutAction } from 'utils/auth/actions';

class Logout extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function

  componentWillMount() {
    this.props.authLogout({ reason: 'AUTH_LOGOUT_ROUTE' });
  }

  render() {
    return null;
  }
}

Logout.propTypes = {
  authLogout: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return {
    authLogout: (data) => dispatch(authLogoutAction(data)),
  };
}

export default connect(null, mapDispatchToProps)(Logout);
